/* eslint-disable */
export default {
  confirmationInfo:
    '이전 통화에 대한 저장되지 않은 편집 내용이 손실됩니다. 새 통화에 대해 작업하시겠습니까?',
  log: '기록',
  save: '저장 후 새로 작업',
  discard: '취소 후 새로 작업',
  stay: '이전 작업 유지',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
